<template>
  <div>
    <v-snackbar top :color="snackbar.color" v-model="snackbar.model">{{
      snackbar.msg
    }}</v-snackbar>

    <v-row>
      <!-- send invite -->
      <v-col cols="12" md="4" order-md="2" v-if="showForm">
        <v-toolbar v-bind="toolbarProps">ADD VOTERS</v-toolbar>

        <v-form
          ref="form"
          v-model="valid"
          :lazy-validation="lazy"
          @submit.prevent="addVoters"
        >
          <v-row no-gutters>
            <v-col cols="12" v-if="isBulk">
              <v-file-input
                placeholder="upload voters"
                v-bind="fieldProps"
                accept="text/csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                :rules="[rules.file, rules.excel]"
                dense
                prepend-inner-icon="mdi-paperclip"
                prepend-icon=""
                @change="onFileChange"
              ></v-file-input>
            </v-col>

            <template v-else>
              <v-col cols="12" class="mb-2">
                <v-text-field
                  ref="email"
                  placeholder="email"
                  :rules="emailRules"
                  v-bind="fieldProps"
                  v-model="singleInvite.email"
                  dense
                >
                </v-text-field>
              </v-col>

              <v-col cols="12" class="mb-2">
                <v-text-field
                  ref="phone"
                  placeholder="phone number"
                  :rules="phoneRules"
                  v-bind="fieldProps"
                  v-model="singleInvite.phone_number"
                  :maxlength="10"
                  dense
                >
                </v-text-field>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  placeholder="index number"
                  v-bind="fieldProps"
                  v-model="singleInvite.index_number"
                  dense
                ></v-text-field>
              </v-col>
            </template>

            <div style="width: 100%" class="d-flex justify-end flex-wrap mt-6">
              <v-btn
                v-if="isOrganizer"
                :text="!isBulk"
                :class="{ 'is-pressed': isBulk }"
                tile
                @click="isBulk = !isBulk"
                >bulk</v-btn
              >

              <v-btn
                :loading="loading.btn"
                :disabled="!valid || loading.btn"
                depressed
                class="primary ml-3"
                type="submit"
                >add</v-btn
              >
            </div>
          </v-row>
        </v-form>
      </v-col>

      <!-- accepted invites -->
      <v-col cols="12" :md="showForm ? 8 : 12" order-md="1">
        <v-toolbar v-bind="toolbarProps"
          >VOTERS
          <v-spacer />
          <v-btn
            depressed
            class="secondary"
            @click="publish"
            :loading="isPublishing"
            :disabled="isPublishing"
            >publish
          </v-btn>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                style="transform: rotate(-90deg)"
                class="ml-2"
                @click="showForm = !showForm"
              >
                <template v-if="!showForm">mdi-toggle-switch</template>
                <template v-else>mdi-toggle-switch-off</template>
              </v-icon>
            </template>
            <span>{{ showForm ? "hide" : "show" }} form</span>
          </v-tooltip>
        </v-toolbar>

        <v-data-table
          :search="search"
          :headers="headers"
          :items="tableItems"
          class="elevation-1"
          :loading="loading.table"
          v-model="selected"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-text-field
                prepend-inner-icon="mdi-magnify"
                placeholder="search"
                v-bind="fieldProps"
                v-model="search"
                dense
              ></v-text-field>
            </v-toolbar>
          </template>

          <template v-slot:item.added_by="{ item }">
            {{ user.name === item.added_by ? "You" : item.added_by }}
          </template>

          <template v-slot:item.actions="{ item }">
            <v-btn
              :disabled="isPublishing"
              small
              depressed
              @click="publish(item)"
              class="mr-2"
              >publish</v-btn
            >

            <!-- <v-icon small @click="handleAction(item)" v-if="isOrganizer">
              mdi-delete
            </v-icon> -->
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {
  rules,
  fieldProps,
  labelProps,
  toSentenceCase,
  toolbarProps,
} from "@/helpers";
import { mapActions } from "vuex";

import XLSX from "xlsx";

/* eslint-disable */

export default {
  data: () => ({
    rules,
    fieldProps: { ...fieldProps },
    labelProps,
    toolbarProps,

    isMounted: false,
    showForm: true,

    valid: true,
    lazy: false,

    snackbar: {
      model: false,
      msg: "Error!",
      color: "error",
    },

    isPublishing: false,

    tableItems: [],
    selected: [],

    loading: {
      table: false,
      btn: false,
    },

    search: "",

    isBulk: false,

    // single viewer
    singleInvite: {
      index_number: "",
      phone_number: "",
      email: "",
    },

    // bulk viewers
    bulkInvites: null,

    // headers
    headers: [
      {
        text: "EMAIL",
        value: "email",
        align: "start",
        groupable: false,
      },
      {
        text: "PHONE #",
        value: "phone_number",
      },
      {
        text: "ADDED BY",
        value: "added_by",
      },
      {
        text: "INDEX #",
        value: "index_number",
      },
      { text: "ACTIONS", value: "actions", sortable: false },
    ],
  }),

  computed: {
    voters() {
      return this.$store.getters.getCollection("voters");
    },

    user() {
      const usr = localStorage.getItem("usr");
      return JSON.parse(usr);
    },

    isOrganizer() {
      return localStorage.getItem("typ")[0] === "o";
    },

    phoneRules() {
      // either phone or email is required
      if (!this.isMounted) return [rules.required, rules.phone];

      const { email, phone_number: phone } = this.singleInvite;
      if (email.length == 0 && phone.length == 0)
        return [rules.required, rules.phone];

      if (phone.length !== 0) return [rules.phone];

      // $refs is now available
      return this.$refs.email.valid ? [] : [rules.required, rules.phone];
    },

    emailRules() {
      // either phone or email is required
      if (!this.isMounted) return [rules.required, rules.email];

      const { email, phone_number: phone } = this.singleInvite;
      if (email.length == 0 && phone.length == 0)
        return [rules.required, rules.email];

      if (email.length !== 0) return [rules.email];

      // $refs is now available
      return this.$refs.phone.valid ? [] : [rules.required, rules.email];
    },
  },

  methods: {
    ...mapActions(["makeFetch"]),

    // handleAction(item) {
    //   console.log(item);
    // },

    showSnackbar(event) {
      this.snackbar.msg = !event.pre ? toSentenceCase(event.msg) : event.msg;
      this.snackbar.color = event.color;
      this.snackbar.model = true;
    },

    async publish(voter) {
      this.isPublishing = true;

      let request = {
        method: "post",
        goTo: "/polls",
        useId: this.$route.params.id,
        way: "/voter/publish",
      };

      if (!!voter.id) request = { ...request, data: { voter_id: voter.id } };

      const res = await this.makeFetch({ ...request })
        .catch(console.error)
        .finally(() => (this.isPublishing = false));

      if (!res) {
        this.showSnackbar({
          msg: "Connection error",
          color: "error",
        });
        return;
      }

      const isPublished = res.is_published;
      let msg = "";
      let color = "";

      if (res.success) {
        msg = isPublished ? "Published" : res.message;
        color = isPublished ? "secondary" : "info";
      } else {
        msg = res.message;
        color = "error";
      }

      this.showSnackbar({
        msg: msg,
        color: color,
        pre: res.success && !isPublished,
      });
    },

    onFileChange(file) {
      if (file) {
        const reader = new FileReader();

        reader.readAsBinaryString(file);

        reader.onload = () => {
          const data = reader.result;

          const workbook = XLSX.read(data, { type: "binary" });
          workbook.SheetNames.forEach((sheetName) => {
            const xlRowObjectArray = XLSX.utils.sheet_to_row_object_array(
              workbook.Sheets[sheetName]
            );

            const jsonString = JSON.stringify(xlRowObjectArray);

            this.bulkInvites = JSON.parse(jsonString);
          });
        };

        reader.onerror = (err) => {
          console.error(err);
        };
      } else {
        console.error("no file");
      }
    },

    async addVoters() {
      if (!this.$refs.form.validate()) return;

      this.loading.btn = true;

      let data = [];

      if (this.isBulk) {
        data = [
          ...this.bulkInvites.map((item) => {
            return {
              index_number: item["index number"],
              email: item.email,
              phone_number: item["phone number"],
            };
          }),
        ];
      } else {
        data = this.singleInvite;
        this.isOrganizer
          ? (data.organizer_id = this.user.id)
          : (data.agent_id = this.user.id);
      }

      const res = await this.makeFetch({
        method: "post",
        goTo: "/polls",
        useId: this.$route.params.id,
        way: "/voters",
        stateVar: !this.isBulk && "voters",
        data: this.isBulk
          ? { bulk: true, voters: data }
          : { single: true, voter: data },
      })
        .catch(console.error)
        .finally(() => (this.loading.btn = false));

      if (res.success) {
        this.singleInvite.index_number = "";
        this.singleInvite.email = "";
        this.singleInvite.phone_number = "";
        this.bulkInvites = null;
      }

      this.showSnackbar({
        msg: res.success
          ? "Added"
          : res.message
          ? res.message
          : "Connection error. Please try again later!",
        color: res.success ? "primary" : "error",
        pre: !res.success && !res.message,
      });
    },
  },

  async mounted() {
    this.loading.table = true;
    await this.makeFetch({
      method: "get",
      goTo: `/polls/${this.$route.params.id}`,
      way: "/voters",
      stateVar: "voters",
    })
      .catch(console.error)
      .finally(() => {
        this.loading.table = false;
      });

    this.isMounted = true;
  },

  watch: {
    voters(val) {
      this.tableItems = [...val];
    },
  },
};
</script>

<style>
.is-pressed {
  box-shadow: inset 0 2px 1px -1px rgba(0, 0, 0, 0.2),
    inset 0 1px 1px 0 rgba(0, 0, 0, 0.14), inset 0 1px 3px 0 rgba(0, 0, 0, 0.12) !important;
}
</style>
